import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-832af368"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "warning-msg" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" The order is being processed. You cannot edit the order information ")
const _hoisted_4 = { class: ".btn-action" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Import Excel ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Add SKU ")
const _hoisted_7 = { class: "btn-action" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_11 = { class: "clearfix" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" a sample CSV template to see the required format. ")
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Import")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_warning = _resolveComponent("warning")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_item_list = _resolveComponent("item-list")!
  const _component_upload = _resolveComponent("upload")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _component_AddSku = _resolveComponent("AddSku")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_section_layout_content, _normalizeProps(_guardReactiveProps(_ctx.content)), {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      "label-width": "120px",
                      ref: "formOrder",
                      model: _ctx.state.order
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "Reference ID",
                          prop: "referenceId1",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.state.order.referenceId1,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.order.referenceId1) = $event)),
                                      disabled: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "Warehouse",
                          prop: "warehouseId",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.state.order.warehouseId,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.order.warehouseId) = $event)),
                                      placeholder: "Select Warehouse",
                                      style: {"width":"100%"},
                                      filterable: "",
                                      remote: "",
                                      "reserve-keyword": "",
                                      "default-first-option": "",
                                      "remote-method": _ctx.getWarehouses,
                                      disabled: 
                      _ctx.state.order.status !== 'Unfulfilled' &&
                      _ctx.state.isSubmited === _ctx.ACTION.UPDATE
                    
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.warehouses, (warehouse) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: warehouse._id,
                                            label: warehouse.name,
                                            value: warehouse._id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "remote-method", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_card, { class: "my-3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("span", _hoisted_2, [
                        (
                  _ctx.state.order.status !== 'Unfulfilled' &&
                  _ctx.state.isSubmited === _ctx.ACTION.UPDATE
                )
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "warning"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { size: 50 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_warning)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_3
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.isShowModalImport = true)),
                          disabled: 
                  _ctx.state.order.status !== 'Unfulfilled' &&
                  _ctx.state.isSubmited === _ctx.ACTION.UPDATE
                
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_button, {
                          onClick: _ctx.showAddSku,
                          disabled: 
                  _ctx.state.order.status !== 'Unfulfilled' &&
                  _ctx.state.isSubmited === _ctx.ACTION.UPDATE
                
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ])
                    ]),
                    _createVNode(_component_item_list, { orderItems: _ctx.orderItems }, null, 8, ["orderItems"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, {
                    onClick: _ctx.onSubmit,
                    disabled: 
              _ctx.state.order.status !== 'Unfulfilled' &&
              _ctx.state.isSubmited === _ctx.ACTION.UPDATE
            
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.state.isShowModalImport,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.isShowModalImport) = $event)),
          title: "Import SKU"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_el_button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.isShowModalImport = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onSubmitImport
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                action: "#",
                accept: '.csv',
                multiple: false,
                "auto-upload": false,
                "on-change": _ctx.onChangeFiles,
                "file-list": _ctx.fileList
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_upload)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["accept", "on-change", "file-list"])
            ]),
            _createElementVNode("p", null, [
              _createVNode(_component_router_link, {
                to: { path: '/' },
                class: "text-blue-600"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _hoisted_13
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 16),
    _createVNode(_component_AddSku, {
      isShowAddSku: _ctx.state.isShowAddSku,
      onCancel: _ctx.handleAddSkuCancel
    }, null, 8, ["isShowAddSku", "onCancel"])
  ], 64))
}